import { render, staticRenderFns } from "./insight-views.vue?vue&type=template&id=088be4db&"
import script from "./insight-views.ts?vue&type=script&lang=js&"
export * from "./insight-views.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports